import React from 'react';

export const DownloadIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    width="20" 
    height="20" 
    fill="none" 
    viewBox="0 0 20 20"
    {...props}
  >
    <path 
      fill={props.fill || "#101018"} 
      d="M14.875 7.5a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2h-9.75a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2h4.25v4.741l-2.91-2.91a.625.625 0 1 0-.884.884l3.977 3.977c.244.245.64.245.884 0l3.977-3.977a.625.625 0 1 0-.884-.884l-2.91 2.91V7.5zM10 1.875c.345 0 .625.28.625.625v5h-1.25v-5c0-.345.28-.625.625-.625"
    />
  </svg>
);

export const SearchIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
    <mask id="search-icon-mask" width="24" height="24" x="0" y="0" maskUnits="userSpaceOnUse" style={{ maskType: 'alpha' }}>
      <path fill="#d9d9d9" d="M0 0h24v24H0z"/>
    </mask>
    <g mask="url(#search-icon-mask)">
      <path 
        fill="#6e6e6e" 
        d="M9.52 15.616q-2.562 0-4.339-1.777Q3.405 12.062 3.404 9.5t1.777-4.338T9.52 3.385t4.338 1.777T15.635 9.5q0 1.071-.36 2.046a5.7 5.7 0 0 1-.96 1.696l5.755 5.754q.207.208.212.522a.7.7 0 0 1-.212.532.72.72 0 0 1-.527.217.72.72 0 0 1-.527-.217l-5.754-5.754q-.75.62-1.725.97t-2.017.35m0-1.5q1.933 0 3.274-1.342 1.341-1.34 1.341-3.274 0-1.932-1.341-3.274-1.342-1.341-3.274-1.341-1.933 0-3.274 1.341Q4.904 7.568 4.904 9.5q0 1.933 1.342 3.274 1.34 1.342 3.274 1.342"
      />
    </g>
  </svg>
);

export const FullscreenIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg viewBox="0 0 16 16" fill="none" {...props}>
    <path
      d="M10 2h4v4M6 14H2v-4M14 6V2h-4M2 10v4h4"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

